import { MarvStringService } from '@marv/services';
import { OperationCard } from '@app/models';

export class Photo {
    
    id: number;
    logaUid: string;
    referenceDate: number;
    missionId: number;    
    missionCode: string;
    activityId: number; //OU storeCheckId pour lgg  
    operationId: number;
    operationName: string;
    operationSource: string;
    typeOfMission: string;
    storeName: string;
    storeCode: string;
    storeCity: string;
    customerAreaId: number;
    customerSectorId: number;
    tagName: string;
    tagNameCleaned: string;
    modelName: string;
    modelNameCleaned: string;
    modelCode: string;
    source: string;
    retailerCode: string;
    retailerName: string;
    urlPicture: string;
    urlThumbnail: string;
    published: boolean;
    instantPhotoTag: string;
    instantPhotoTagCleaned: string;
    lastModified: number;
    uniqid: string;
    
    /**
     * Pour creer le token pour se connecter à ANIMA
     */
    logaWorkDayId: number;
    
    static FromJson(operation: OperationCard, json: any): Photo {
        const o: Photo = new Photo();

        o.id = json['id'];
        o.logaUid = json['logaUid'];
        o.referenceDate = json['referenceDate'];
        o.storeName = json['storeName'];
        o.storeCode = json['storeCode'];
        o.storeCity = json['storeCity'];
        o.customerAreaId = json['customerAreaId'];
        o.customerSectorId = json['customerSectorId'];
        o.tagName = json['tagName'];
        o.tagNameCleaned = MarvStringService.RemoveAccents(json['tagName']).trim().toLowerCase();
        o.modelName = json['dataModelName'];
        o.modelNameCleaned = MarvStringService.RemoveAccents(json['dataModelName']).trim().toLowerCase();
        o.modelCode = json['dataModelCode'];
        o.source = json['source'];

        o.operationId = operation.id;
        o.operationName = operation.name;
        o.operationSource = operation.type;
        o.typeOfMission = (operation.type === 'loga' ? operation.typeOfMissionCode : 'PERM');
        
        o.missionId = json['missionId'];
        o.missionCode = json['missionCode'];
        o.logaWorkDayId = json['logaWorkDayId'];
        o.activityId = json['activityId'];
        o.retailerCode = json['retailerCode'];
        o.retailerName = json['retailerName'];
        o.urlPicture = json['urlPicture'];
        o.urlThumbnail = json['urlThumbnail'];
        o.published = json['published'];
        o.instantPhotoTag = json['instantPhotoTag'];
        o.instantPhotoTagCleaned = MarvStringService.RemoveAccents(json['instantPhotoTag']).trim().toLowerCase();
        o.lastModified = json['lastModified'];
        
        o.uniqid = window.crypto.randomUUID();
        
        return o;
    }

}

export class InstantPhotoFilterTag{
    rank!: number;
    tag!: string;
    normalizedTag!: string;
    operationIDs!: number[];
    contextIDs!: number[];
    counter?: number;
    uiHidden?: boolean = false;
    
    static FromJson(o: any): InstantPhotoFilterTag{
        let i = new InstantPhotoFilterTag();
        i.rank = o.rank;
        i.tag = o.tag;
        i.normalizedTag = MarvStringService.RemoveAccents(o.tag).trim().toLowerCase();
        i.operationIDs = o.operationIDs;
        i.contextIDs = o.contextIDs;
        return i;
    }
}

export interface PhotoSearchOption {
  value: number;
  title: string;
}

export class PhotoSearchCriteria{
    id!: number;
    code!: string;
    name!: string;
    rank!: number;
    rangeId?: number;
    disabled?: boolean;
}

export class AnimaPhotoSearchProductRange{
    id!: number;
    code!: string;
    name!: string;
    rank!: number;
    productCategoryId!: number;

    products!: Array<PhotoSearchCriteria>;
    productChunks!: any[][];
    posms!: Array<PhotoSearchCriteria>;
    posmChunks!: any[][];
}

export class AnimaPhotoSearchProductCategory {
    id!: number;
    code!: string;
    name!: string;
    rank!: number;
    useImageRec!: boolean
    ranges!: Array<AnimaPhotoSearchProductRange>;
    hasProducts!: boolean;
    hasPosms!: boolean;
}

export class AnimaPhotoSearchCriteria {
    photoTags!: Array<PhotoSearchOption>;
    photoTagCriteriaChunks!: PhotoSearchOption[][];
    isaReportDataModelGroups!: Array<IsaReportDataModelGroup>;
    productDataModels!: Array<PhotoSearchOption>;
    productDataModelsChunks!: any[][];
    productCategories!: Array<AnimaPhotoSearchProductCategory>;
}

export class IsaReportDataModelGroup extends PhotoSearchCriteria {
    isaReportDataModels!: Array<PhotoSearchCriteria>;
    isaReportDataModelChunks!: any[][];
}

export class PearlsPhotoProductCategoryStructure {
    productCategory!: Array<PearlsPhotoProductCategory>;
    hasProducts!: boolean;
    hasPosms!: boolean;
}

export class PearlsPhotoProductCategory {
    id!: number;
    code!: string;
    name!: string;
    rank!: number;
    useImageRec!: boolean
    ranges!: Array<PearlsPhotoProductRange>;
    hasProducts!: boolean;
    hasPosms!: boolean;
}

export class PearlsPhotoProductRange{
    id!: number;
    code!: string;
    name!: string;
    rank!: number;
    productCategoryId!: number;

    products!: Array<PhotoSearchCriteria>;
    productChunks!: Array<Array<any>>;
    posms!: Array<PhotoSearchCriteria>;
    posmChunks!: Array<Array<any>>;
}

export class PearlsPhotoStoreCheckQuestionCriteria extends PhotoSearchCriteria{
    scDataGroup!: number
}

export class PearlsPhotoStoreCheckQuestionStructure {
    group: PhotoSearchCriteria;
    storeCheckDataModels: Array<PearlsPhotoStoreCheckQuestionCriteria> = [];
}

export class PearlsPhotoSearchCriteria {
    photoTagCriteria!: Array<PhotoSearchCriteria>;
    photoTagCriteriaChunks!: Array<Array<PhotoSearchCriteria>>;
    prDmPhotoCriteria!: Array<PhotoSearchCriteria>;
    prDmPhotoCriteriaChunks!: Array<Array<PhotoSearchCriteria>>;
    poDmPhotoCriteria!: Array<PhotoSearchCriteria>;
    poDmPhotoCriteriaChunks!: Array<Array<PhotoSearchCriteria>>;
    scDmPhotoCriteria!: Array<PearlsPhotoStoreCheckQuestionCriteria>;
    scDmPhotoCriteriaChunks!: Array<PearlsPhotoStoreCheckQuestionStructure>;
    scDataGroupCriteria!: Array<PhotoSearchCriteria>;
    productCategories!: PearlsPhotoProductCategoryStructure|null;
}